import React from 'react';
import { Bets } from '@alien-platform/bo-core';
import { Typography } from '@mui/material';

import { Row } from '@/types/general';
import { paths } from '@/paths';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function QuickLinksTable({ betData }: { betData: Bets }): React.JSX.Element {
  const quickLinksData: Row[] = [
    {
      label: {
        component: (
          <Typography variant="body2" color="var(--mui-palette-text-secondary)" sx={{ flexShrink: 0 }}>
            Total Tickets: <span style={{ color: 'var(--mui-palette-text-primary)' }}>100</span>
          </Typography>
        ),
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        component: (
          <Typography variant="body2" color="var(--mui-palette-text-secondary)" sx={{ flexShrink: 0 }}>
            Bets: <span style={{ color: 'var(--mui-palette-text-primary)' }}>100</span>
          </Typography>
        ),
      },
      value: {
        link: {
          href: paths.dashboard.bets.playerBets(betData.playerBefore.playerCode),
        },
      },
    },
    {
      label: {
        component: (
          <Typography variant="body2" color="var(--mui-palette-text-secondary)" sx={{ flexShrink: 0 }}>
            All Transactions: <span style={{ color: 'var(--mui-palette-text-primary)' }}>100</span>
          </Typography>
        ),
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        component: (
          <Typography variant="body2" color="var(--mui-palette-text-secondary)" sx={{ flexShrink: 0 }}>
            Player Stats Reports: <span style={{ color: 'var(--mui-palette-text-primary)' }}>100</span>
          </Typography>
        ),
        text: 'Player Stats Reports',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
  ];

  return <HorizontalTable tableData={quickLinksData} />;
}
